import { gql } from "@apollo/client";

export const GET_FAQLIST_RESULTS = (skip = 0, tags: string[], preview: boolean) => `
query FAQListResultType {
  faqCollection(preview: ${preview}, limit: 10, order: name_ASC, skip: ${skip} ${
    tags?.length
      ? `, where: {
      contentfulMetadata: {
        tags_exists: true
        tags: {
          id_contains_all: [${tags.map((item) => {
            return `"${item}"`;
          })}]
        }
    }
    })`
      : `)`
  }
  {
	  total
  	items {
      question
      answer {
        json
        links {
          entries {
            hyperlink {
              ... on Page {
                sys {
                  id
                }
                slug
                content {
                  __typename
                }
              }
              ... on FileBlock {
                sys {
                  id
                }
                imageVaultFile
                metaData
                __typename
              }
            }
          }
        }
      }
      contentfulMetadata {
        concepts {
          id
        }
      }
      audienceCollection(limit: 18){
      items{
          audianceId
        }
      }
      sys {
        publishedAt
        firstPublishedAt
        id
      }
      __typename
    }
  }
}`;

export const GET_FAQLIST_QUERY_RESULT = gql`
  query FAQListResultType {
    faqCollection {
      items {
        question
        answer {
          json
          links {
            entries {
              hyperlink {
                ... on Page {
                  sys {
                    id
                  }
                  slug
                  content {
                    __typename
                  }
                }
                ... on FileBlock {
                  sys {
                    id
                  }
                  imageVaultFile
                  metaData
                  __typename
                }
              }
            }
          }
        }
        audienceCollection {
          items {
            audianceId
          }
        }
        sys {
          publishedAt
          firstPublishedAt
          id
        }
        __typename
      }
    }
  }
`;

export const GET_FAQLIST_BY_CONCEPTS_RESULTS = (skip = 0, concepts: string[], preview: boolean) => `
query FAQListResultType {
  faqCollection(preview: ${preview}, limit: 10, order: name_ASC, skip: ${skip} ${
    concepts?.length
      ? `, where: {
        contentfulMetadata: {
          concepts_exists: true
          concepts: {
            id_contains_some: [${concepts.map((id) => `"${id}"`).join(", ")}]
          }
        }
      })`
      : `)`
  }
  {
	  total
  	items {
      question
      answer {
        json
        links {
          entries {
            hyperlink {
              ... on Page {
                sys {
                  id
                }
                slug
                content {
                  __typename
                }
              }
              ... on FileBlock {
                sys {
                  id
                }
                imageVaultFile
                metaData
                __typename
              }
            }
          }
        }
      }
      contentfulMetadata {
        concepts {
          id
        }
      }
      audienceCollection(limit: 18){
      items{
          audianceId
        }
      }
      sys {
        publishedAt
        firstPublishedAt
        id
      }
      __typename
    }
  }
}`;
